module.exports = __webpack_public_path__ + "img/MP.91055a88.svg";